export default __webpack_public_path__ + "static/media/payment-napas.8de3be3a.svg";